(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[229],{

/***/ 77183:
/***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home",
      function () {
        return __webpack_require__(33077);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7401:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/banner-arrow.cfa577cc.png","height":128,"width":127,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAQAAABuBnYAAAAAcElEQVR42mPQ2K5xXOOYhj4DgyYzAwhocAKxu8ZJDUEgzcgAAxq9Gv5AkhUspFmusVTjrsYymFyyxkGNPM0LGi0apzR5gBo1lDSWa6zR0ACqjNaYpzELYYqLRo7mHY2jDBpMmowgCzWENDI1bmhMBwA9thlJOT/Q6QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 48798:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/logo.0a53d968.svg","height":27,"width":204});

/***/ }),

/***/ 2014:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ webHeader)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/navVipEntrance/index.js + 5 modules
var navVipEntrance = __webpack_require__(94726);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/index.js
var teamInfo = __webpack_require__(72838);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/types/teamInfo.js
var types_teamInfo = __webpack_require__(8029);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-identity/lib/index.js
var lib = __webpack_require__(99861);
// EXTERNAL MODULE: ./src/utils/login.tsx + 6 modules
var login = __webpack_require__(93567);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(40582);
;// CONCATENATED MODULE: ./src/components/userInfo/index.tsx
"use client";





// @ts-ignore
const UserInfo = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(815), __webpack_require__.e(4772), __webpack_require__.e(4751), __webpack_require__.e(1022), __webpack_require__.e(3922), __webpack_require__.e(7711), __webpack_require__.e(1697), __webpack_require__.e(7888)]).then(__webpack_require__.bind(__webpack_require__, 19266)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(19266)
            ]
    },
    ssr: false
});
const User = (param)=>{
    let { userInfo , meidouInfo , cutoutInfo  } = param;
    const [callback, setCallback] = (0,react.useState)("");
    const handleOpenVip = (type, params)=>{
        (0,login/* openVipModal */.C2)({
            entrance: "open",
            subscribe_type: type === 2 ? "meidou" : "subscription",
            ...params
        });
    };
    (0,react.useEffect)(()=>{
        setCallback((0,login/* getCallback */.RN)());
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(UserInfo, {
        userInfo: userInfo,
        callback: callback,
        avatarSize: 34,
        meidouAmount: meidouInfo === null || meidouInfo === void 0 ? void 0 : meidouInfo.available_amount,
        cutoutAmount: cutoutInfo === null || cutoutInfo === void 0 ? void 0 : cutoutInfo.left,
        onLogin: login/* jumpToLogin */.lU,
        onLogout: login/* handleLogout */.hY,
        onOpenVipModal: handleOpenVip,
        track: mtstat/* statTrack */.SF,
        onExchangeSuccess: login/* getUserInfo */.bG,
        onJumpToAccount: async (options)=>{
            if (!window.account) {
                await (0,login/* initAccount */.Br)();
            }
            window.account.openPage("/account", {
                clientCallback: options.client_callback
            });
        }
    });
};
/* harmony default export */ const components_userInfo = (/*#__PURE__*/react.memo(User));

// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/teamInfo/teamInfoModal.js
var teamInfoModal = __webpack_require__(4162);
;// CONCATENATED MODULE: ./src/components/teamInfo/index.tsx





function TeamInfo() {
    const handleOpenVip = function() {
        let params = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        (0,login/* openVipModal */.C2)(params);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(teamInfoModal/* default */.Z, {
            onChange: ()=>{
                window.location.reload();
            },
            onOpenVipModal: (params)=>{
                handleOpenVip(params);
            },
            onTrack: mtstat/* statTrack */.SF
        })
    });
}
/* harmony default export */ const components_teamInfo = (/*#__PURE__*/react.memo(TeamInfo));

// EXTERNAL MODULE: ./src/assets/images/logo.svg
var logo = __webpack_require__(48798);
// EXTERNAL MODULE: ./src/hooks/useUserHelper.ts
var useUserHelper = __webpack_require__(39992);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(29358);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/logo/index.js + 2 modules
var dist_logo = __webpack_require__(27041);
// EXTERNAL MODULE: ./src/components/webHeader/index.module.css
var index_module = __webpack_require__(30446);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(15328);
// EXTERNAL MODULE: ./src/utils/event.ts
var utils_event = __webpack_require__(56319);
// EXTERNAL MODULE: ./src/constants/event.ts
var constants_event = __webpack_require__(94386);
// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(78264);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-widgets/dist/wps/utils/index.js
var utils = __webpack_require__(68626);
;// CONCATENATED MODULE: ./src/components/webHeader/index.tsx





















const MeidouInfo = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(815), __webpack_require__.e(4772), __webpack_require__.e(4751), __webpack_require__.e(1022), __webpack_require__.e(3922), __webpack_require__.e(7711), __webpack_require__.e(1697), __webpack_require__.e(7888), __webpack_require__.e(1367)]).then(__webpack_require__.bind(__webpack_require__, 31367)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31367)
            ]
    },
    ssr: false
});
const WebHeader = (props)=>{
    var ref;
    const { isPersonal , onCreate , isWorkSpace =false , style  } = props;
    const userInfo = (0,useUserHelper/* useGetUserInfo */.Jh)();
    const meidouInfo = (0,useUserHelper/* useGetMeidouInfo */.nr)();
    const cutoutInfo = (0,useUserHelper/* useGetCutoutInfo */.rC)();
    const currentIdentity = (0,teamInfo/* useCurrentTeamIdentity */.q5)();
    const [headerStyle, setHeaderStyle] = (0,react.useState)({});
    const isOpenPptCommercialization = (0,store/* useStoreState */.Kw)((state)=>state.isOpenPptCommercialization);
    const isWidgetsConfigDone = (0,store/* useStoreState */.Kw)((state)=>state.isWidgetsConfigDone);
    const handleOpenVip = (params, closeCallback, payCallback)=>{
        !isWorkSpace && (0,mtstat/* statTrack */.SF)("landing_page_click", {
            region: "topnav"
        });
        if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.id)) {
            (0,login/* jumpToLogin */.lU)();
            return;
        }
        (0,login/* openVipModal */.C2)(params, closeCallback, payCallback);
    };
    const handleScroll = ()=>{
        const scrollY = window.scrollY;
        setHeaderStyle({
            // 根据滚动位置透明度自动计算
            backgroundColor: "rgba(255, 255, 255, ".concat(scrollY / 100 > 0.7 ? 0.7 : scrollY / 100, ")"),
            // 高斯模糊
            backdropFilter: "blur(".concat(scrollY / 100 > 25 ? 25 : scrollY / 100, "px)")
        });
    };
    (0,react.useEffect)(()=>{
        (0,login/* getUserInfo */.bG)();
        window.addEventListener("scroll", handleScroll);
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    (0,react.useEffect)(()=>{
        utils_event/* default.on */.Z.on(constants_event/* UPDATE_USER_INFO */.r0, handleUpdateMeidouInfo);
        return ()=>{
            utils_event/* default.off */.Z.off(constants_event/* UPDATE_USER_INFO */.r0, handleUpdateMeidouInfo);
        };
    }, []);
    const handleUpdateMeidouInfo = ()=>{
        (0,login/* getUserInfo */.bG)();
    };
    const handleLogin = ()=>{
        (0,login/* jumpToLogin */.lU)();
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
        className: (index_module_default()).webHeader,
        style: {
            ...headerStyle,
            ...style
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).left,
                children: [
                    isPersonal || !isPersonal && isWidgetsConfigDone ? // @ts-ignore
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_logo/* default */.Z, {
                        logoUrl: (0,utils/* isFromWPS */.ji)() ? undefined : logo/* default.src */.Z.src,
                        height: 30,
                        hideLogo: false,
                        hideSlogan: true,
                        hideCollectTip: true,
                        hideName: (currentIdentity === null || currentIdentity === void 0 ? void 0 : currentIdentity.type) === types_teamInfo/* IdentityType.ENTERPRISE */.Mf.ENTERPRISE,
                        showGuide: false,
                        target: "_self" // 打开首页方式，默认新开窗口，_self/_blank
                    }) : null,
                    isWidgetsConfigDone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components_teamInfo, {}) : null
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).right,
                children: [
                    isOpenPptCommercialization ? /*#__PURE__*/ (0,jsx_runtime.jsx)(navVipEntrance/* default */.Z, {
                        handleClick: ()=>handleOpenVip({
                                entrance: "topnav",
                                subscribe_type: "subscription"
                            }),
                        requestParams: {
                            position: "LivePPT"
                        },
                        track: mtstat/* statTrack */.SF,
                        uid: userInfo === null || userInfo === void 0 ? void 0 : userInfo.id,
                        customBtnText: isOpenPptCommercialization.isHitGroupOne ? "3.8元开通会员" : isOpenPptCommercialization.isHitGroupTwo ? "9.9元开通会员" : ""
                    }) : null,
                    onCreate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                        className: (index_module_default()).createBtn,
                        onClick: onCreate,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFont/* default */.Z, {
                                className: (index_module_default()).createIcon,
                                name: "PlusCircleBold",
                                fontSize: 16
                            }),
                            "从空白创建"
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(MeidouInfo, {
                        meidouInfo: meidouInfo,
                        project: constants/* SCENE */.vX,
                        onLogin: handleLogin,
                        onUpdateMeidouInfo: handleUpdateMeidouInfo,
                        autoSendDailyPresentedApi: true,
                        vipInfo: {
                            is_vip: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.is_vip) || false
                        },
                        onOpenVipModal: (params, closeCallback, payCallback)=>handleOpenVip(params, closeCallback, payCallback),
                        track: mtstat/* statTrack */.SF,
                        hideMeiDouRecordsEntrance: !!((ref = (0,lib/* getLocalIdentity */.u5)()) === null || ref === void 0 ? void 0 : ref.oid)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components_userInfo, {
                        userInfo: userInfo,
                        meidouInfo: meidouInfo,
                        cutoutInfo: cutoutInfo
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const webHeader = (WebHeader);


/***/ }),

/***/ 94386:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aG": () => (/* binding */ UPDATE_PRICE),
/* harmony export */   "r0": () => (/* binding */ UPDATE_USER_INFO)
/* harmony export */ });
/* unused harmony export AI_PPT_SCROLL */
const UPDATE_USER_INFO = "UPDATE_USER_INFO";
const AI_PPT_SCROLL = "AI_PPT_SCROLL";
const UPDATE_PRICE = "UPDATE_PRICE";


/***/ }),

/***/ 39992:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D3": () => (/* binding */ useGetIsRequested),
/* harmony export */   "Jh": () => (/* binding */ useGetUserInfo),
/* harmony export */   "nr": () => (/* binding */ useGetMeidouInfo),
/* harmony export */   "rC": () => (/* binding */ useGetCutoutInfo)
/* harmony export */ });
/* unused harmony exports useSetUserInfo, useSetMeidouInfo */
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(29358);

const useGetUserInfo = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.userInfo);
};
const useSetUserInfo = ()=>{
    return useStoreActions((actions)=>actions.userModel.setUserInfo);
};
const useGetMeidouInfo = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.meidouInfo);
};
const useSetMeidouInfo = ()=>{
    return useStoreActions((actions)=>actions.userModel.setMeidouInfo);
};
const useGetCutoutInfo = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.cutoutInfo);
};
const useGetIsRequested = ()=>{
    return (0,_store__WEBPACK_IMPORTED_MODULE_0__/* .useStoreState */ .Kw)((state)=>state.userModel.isRequested);
};


/***/ }),

/***/ 73335:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ layout)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/script/index.tsx


const ScriptCustomize = (props)=>{
    const { children , id =Math.random().toString(36).slice(2) , ...resetProps } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
        id: id,
        ...resetProps,
        dangerouslySetInnerHTML: {
            __html: children ? "(".concat(children.toString(), ")();") : ""
        }
    });
};
/* harmony default export */ const components_script = (ScriptCustomize);

;// CONCATENATED MODULE: ./src/assets/images/favicon.ico
/* harmony default export */ const favicon = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/favicon.3e797464.ico","height":60,"width":60});
;// CONCATENATED MODULE: ./src/utils/hmt.ts
/* eslint-disable */ /**
 * 官网百度统计
 */ /* harmony default export */ const hmt = (()=>{
    var _hmt = _hmt || [];
    (function() {
        var ref;
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?948a3e71e024991ef78897ecf6377e4e";
        var s = document.getElementsByTagName("script")[0];
        (ref = s.parentNode) === null || ref === void 0 ? void 0 : ref.insertBefore(hm, s);
    })();
});

;// CONCATENATED MODULE: ./src/layout/head/index.tsx





const PublicHead = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "renderer",
                        content: "webkit"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        httpEquiv: "X-UA-Compatible",
                        content: "IE=edge,chrome=1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "viewport",
                        content: "width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "applicable-device",
                        content: "pc,mobile"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "referrer",
                        content: "no-referrer-when-downgrade"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        type: "image/x-icon",
                        href: favicon.src
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.designkit.cn/ppt/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_script, {
                id: "init-hmt",
                children: hmt
            })
        ]
    });
};
/* harmony default export */ const layout_head = (PublicHead);

;// CONCATENATED MODULE: ./src/layout/index.tsx



const Layout = (props)=>{
    const { children  } = props;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layout_head, {}),
             false && /*#__PURE__*/ 0,
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            })
        ]
    });
};
/* harmony default export */ const layout = (Layout);


/***/ }),

/***/ 33077:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": () => (/* binding */ __N_SSP),
  "default": () => (/* binding */ home)
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/pageComponents/mobileHome/index.module.css
var index_module = __webpack_require__(23254);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./src/layout/index.tsx + 4 modules
var layout = __webpack_require__(73335);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/assets/images/logo.svg
var logo = __webpack_require__(48798);
// EXTERNAL MODULE: ./src/utils/mtstat.ts
var mtstat = __webpack_require__(40582);
// EXTERNAL MODULE: ./src/pageComponents/mobileHome/components/module/index.module.css
var module_index_module = __webpack_require__(68253);
var module_index_module_default = /*#__PURE__*/__webpack_require__.n(module_index_module);
// EXTERNAL MODULE: ./src/assets/images/svip_badage.png
var svip_badage = __webpack_require__(13001);
;// CONCATENATED MODULE: ./src/pageComponents/mobileHome/components/module/index.tsx




const Module = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (module_index_module_default()).module,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (module_index_module_default()).moduleTitle,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            "动态模式全新推出，让PPT汇报更生动",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: svip_badage/* default.src */.Z.src,
                                alt: "badge",
                                width: 20,
                                className: (module_index_module_default()).badge
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (module_index_module_default()).animation,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (module_index_module_default()).animationInner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (module_index_module_default()).animationItem,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (module_index_module_default()).animationItemFlex,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/6761622898f645678.webp)"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/6761623d764052236.webp)"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (module_index_module_default()).animationItemFlex,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/6761625021e239641.webp)"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/67628f7d8b6de8861.webp)"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (module_index_module_default()).animationSubTitle,
                                    children: "动态素材模板"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (module_index_module_default()).animationInner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (module_index_module_default()).animationVideoItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                        src: "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/0a0caf0653023a7c0b090f82b87a8ed9 (1).mp4",
                                        autoPlay: true,
                                        muted: true,
                                        loop: true,
                                        playsInline: true,
                                        "webkit-playsinline": "true",
                                        "x5-playsinline": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (module_index_module_default()).animationSubTitle,
                                    children: "一键开启演示动画"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const components_module = (/*#__PURE__*/react.memo(Module));

// EXTERNAL MODULE: ./src/constants/index.ts
var constants = __webpack_require__(78264);
;// CONCATENATED MODULE: ./src/assets/images/func-img-1-1.png
/* harmony default export */ const func_img_1_1 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/func-img-1-1.d09d127b.png","height":878,"width":1282,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAiUlEQVR42g3GwQ2CQBBA0T/DElAsgBMFeOBuLMNKrMtqjBWoMSZ6MSro4rAjp/fkdExb+7EB6QAVBdzTmKTKc9+F0VjFL+vL1XGH6WQKTeOocFage7xgGIkE7DNgz47YR0DogmbM6lpoWyvMDBFFVcL9lk96GYpS9iK+7PvsjQdFADzNK1+4y+EP8c09XtpiT6IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/func-img-1-2.png
/* harmony default export */ const func_img_1_2 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/func-img-1-2.6980a277.png","height":878,"width":1282,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAjklEQVR42g3IQQ7BUBQF0Pva59eXRiRiahXshW2wKzZjCSZMSBDVpr/vv6uTMzhy4/2QaDsHGggKGQHpAOog5VkH2iaLbx2GxB5GwwJz1Ij4Il2LKLO2tA6f5tIvc7A1V5bzux+QEFH9NCDEjkSbX5XqBGFsZdQMYCpllKc/joXoXqENwcKZQYETXpM8/QFOdEfQEWYU/QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/func-img-1-3.png
/* harmony default export */ const func_img_1_3 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/func-img-1-3.32b0c7a6.png","height":878,"width":1282,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAk0lEQVR4nB2OMQrCQBRE30+EGFi0UhAPoccxtt5Ar2Nho2CuYusNBAtDQEMk7urud8kwj4GpnlQ2bJ3qSpU2kqQJZBBcwIQgpdw//uSVIhGIJ68mrgOTwyinlIcLe+vYPN/Y+Zj0coNrLX451Wwx4yC1DUf3Zd10MDH0qVoYDnrOUne6Ay1Sof15EjQKaKxiNFD+AZaGSB1lVoyLAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/func-img-2-1.png
/* harmony default export */ const func_img_2_1 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/func-img-2-1.93fc0776.png","height":776,"width":1148,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAoklEQVR4nA3OzQoBURiA4febMTJFiVI2NpaSbO3YKBtX5yLchGJnYaEs/GxRftI4MzmZM3MOd/CIyl3mCb614ATi5MNdKeKggbFeLufL2d2MJizVqUURz+eRilGsowyv1UdW85k7PLZUeiM+cRW72TNOliy6EwbDKXJ7Kfc+7dA24SpVmsZSDkNMu0Ot6CMv8zc4/Fx/CYIihZKgU0i1Q8TlPxehTEjuVt35AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/func-img-2-2.png
/* harmony default export */ const func_img_2_2 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/func-img-2-2.0ac5321a.png","height":776,"width":1148,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAi0lEQVR42h2NSQ6CMABFe/8L6BE8hlNC4taNunBhCoRiGFo60uRZXP2fPwopm/x8vKjrFucTxkasS4yzZZhMFlINNINBF3HSHtn2yEYh647JeMRZeU7vjmqC7xKZjfsbdb8UDIhDdWe323P7KJRdy6xm1CVUuA0r4jqTj33i0seysH1vTUcMgRBS/gEpBpWMfh0fhAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/func-img-2-3.png
/* harmony default export */ const func_img_2_3 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/func-img-2-3.934f9d8c.png","height":776,"width":1148,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAfElEQVR42g3MSw6CMBRA0e5/EbIph0aDxGgQsLblvf7opYMzPcYVqgB6gBTYS+sgAVapxsbC+BhZ5oWYMiVXdlGutztWD4xLB/OyESSyWc+2Ol7PicswsPqM6SUSE0Ej3jnsZ+L3fSOqeG2Yf2o1pIbv3J7xXZCC08YaqCd9KZlPTjsDjwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});
;// CONCATENATED MODULE: ./src/assets/images/m-func-img-1-1.png
/* harmony default export */ const m_func_img_1_1 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-func-img-1-1.1e294fa4.png","height":121,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAlElEQVR42h3KOY7CUBQF0brmmUbuQepWg5AggB2w/8VAQGJmAgaB/f9lkKqyo8U8L9tGP0VBBpAM4LZVRMk6cmJ8v5nVCgBSAgn6fVN9UkXKuF6L7dGUXdhvxOUEs571BM0L6Ovb/A+MbUZDcBadEG2C+OiK6cT8/t24XhsiOpRRsN31uJxVqK7zGVRJ8BrzzkbgwwP9dkLn2GadRQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/m-func-img-1-2.png
/* harmony default export */ const m_func_img_1_2 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-func-img-1-2.926b3aa2.png","height":121,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAmUlEQVR42hWNQQrCMBREZ/6PMbUiLgRxoeD97+AxBFeCuFAsbrTYNk2+6XurBwPDW76fI9KeZDQYUTAzFMRBWxcxHkekMFhERoIVQ3FjNT7oV85zNmhOwaXOHMM0KrZQrVCZhyxQ8/274Po9YU7hTg90mXzGF1HaKURmDPC6JpTo0MLLEhQrqWCTm4fSbQU0mtCmE2bYpOX+D0OsQo82TtmNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/m-func-img-1-3.png
/* harmony default export */ const m_func_img_1_3 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-func-img-1-3.7db01c3c.png","height":121,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAi0lEQVR42gWAO7IBQRiFv/P3dFNz60aYHUjsPxPahsAjIhAobz19lE7vcfttDEDFCEE2VBM2Vx2fY204YXg3GF9AFaWYlEUk8eksUgvPcnh3Ca/34c0hrIa7SUjnG9ye0nJh5r14VdMXyCE6TPxnmIbBsBrM8Ae1QTJ0brr3xQXwt6FPhUnC04RsHj83rkZ1cYfhEwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/constants/home.ts










const footerInfo = {
    copyright: ' 美图公司 版权所有 &nbsp;&nbsp;违法和不良信息举报电话：400-990-9696, 网络文化经营<br/><a target="_blank" href="https://public.static.meitudata.com/meitu/business-license/meituwang/Meitu-business-license--20221216.pdf">营业执照</a> &nbsp; <a target="_blank" href="https://public.static.meitudata.com/meitu/business-license/meituwang/ICP-EDI-2019-2024.pdf">经营许可证</a> &nbsp; <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=35020302000186">闽公网安备 35020302000186号</a>, <a target="_blank" href="https://beian.miit.gov.cn">闽B2-20040192</a>, <a target="_blank" href="https://public.static.meitudata.com/meitu/business-license/meituwang/network-culture-2021-2024.pdf">闽网文(2021)3392-058号</a>, <a target="_blank" href="https://beian.cac.gov.cn/#/index">网信算备 350203814951001230023号</a><br/>厦门美图网科技有限公司 地址:厦门市同安区西柯镇美峰创谷美图大厦',
    cols: [
        {
            title: "模板",
            key: "moban",
            mtValue: "template",
            list: [
                {
                    title: "电商",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?sceneId=00218")
                },
                {
                    title: "社交媒体",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?sceneId=00105")
                },
                {
                    title: "微信营销",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?sceneId=00106")
                },
                {
                    title: "微信公众号",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?sceneId=00985")
                },
                {
                    title: "行政办公/教育",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?sceneId=00219")
                },
                {
                    title: "生活娱乐",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?sceneId=001457")
                },
                {
                    title: "PPT",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/templates?fid=002130")
                }
            ]
        },
        {
            title: "支持与服务",
            key: "service",
            mtValue: "service",
            list: [
                {
                    title: "关于我们",
                    url: "https://www.meitu.com/"
                },
                {
                    title: "加入我们",
                    url: "https://hr.meitu.com/social-recruitment/meitu/54137/#/"
                },
                {
                    title: "用户协议",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/agreement")
                },
                {
                    title: "隐私政策",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/legal-agreement")
                },
                {
                    title: "热门搜索",
                    url: "https://www.designkit.cn/hot"
                }
            ]
        },
        {
            title: "友情链接",
            key: "link",
            mtValue: "link",
            list: [
                {
                    title: "供稿中心",
                    url: "https://".concat((0,constants/* getPreFix */.X6)(), "mcp.meitu.com/materials#/Entrance?matrix_channel=").concat(constants/* MATRIX_CHANNEL */.cr)
                },
                {
                    title: "美图秀秀网页版",
                    url: "".concat((0,constants/* getDesignHome */.y$)(), "/editor/")
                },
                {
                    title: "美图抠图",
                    url: "https://".concat((0,constants/* getPrePageFix */.OG)(), ".designkit.cn/cutout/?matrix_channel=").concat(constants/* MATRIX_CHANNEL */.cr)
                },
                {
                    title: "Wink",
                    url: "https://wink.meitu.com/?channel=xdesignweb_blogroll_7"
                }
            ]
        }
    ]
};
const pptUrl = "https://".concat((0,constants/* getPrePageFix */.OG)(), ".designkit.cn/ppt/edit?from=ppt_landingpage");
const cardList = [
    {
        title: "输入主题生成",
        desc: "一句话输入你需要制作的PPT主题，AI智能生成包含文字和排版的完整PPT，任何主题都可完成。",
        url: "".concat(pptUrl, "&activeTab=0"),
        img: func_img_1_1.src,
        statBtnKey: "one_sentence"
    },
    {
        title: "粘贴文本生成",
        desc: "输入你已有的文本内容，不论是大纲、笔记、摘要或者草稿，AI帮你润色生成高质量PPT。",
        url: "".concat(pptUrl, "&activeTab=1"),
        img: func_img_1_2.src,
        statBtnKey: "paste_text"
    },
    {
        title: "导入文件生成",
        desc: "支持导入word、pdf、ppt、xmind、txt等多种文件格式，一键上传秒变全新PPT。",
        url: "".concat(pptUrl, "&activeTab=2"),
        img: func_img_1_3.src,
        statBtnKey: "import_file"
    }
];
const mCardList = [
    {
        title: "输入主题",
        desc: "输入你需要生成的PPT主题，就能获得包含文字和排版的PPT，任何主题都可以试试。",
        img: m_func_img_1_1.src,
        statBtnKey: "one_sentence"
    },
    {
        title: "粘贴文本",
        desc: "只需一句话，输入你想要的PPT主题，AI就能帮你生成包含文案和排版的高质量PPT。",
        img: m_func_img_1_2.src,
        statBtnKey: "paste_text"
    },
    {
        title: "导入文件",
        desc: "支持导入word、pdf、ppt、xmind、txt等多种文件格式，一键上传秒变全新PPT。",
        img: m_func_img_1_3.src,
        statBtnKey: "import_file"
    }
];
const cardList2 = [
    {
        title: "AI生图",
        desc: "支持生成海量风格的高质量配图。",
        url: pptUrl,
        img: func_img_2_1.src,
        statBtnKey: "ai_image"
    },
    {
        title: "AI文本润色",
        desc: "支持文本重写、美化、扩写、缩写，并可选择文字风格。",
        url: pptUrl,
        img: func_img_2_2.src,
        statBtnKey: "ai_text"
    },
    {
        title: "智能设计",
        desc: "提供海量图标、贴纸、花字等行业正版素材，编辑美化随心创作。",
        url: pptUrl,
        img: func_img_2_3.src,
        statBtnKey: "smart_design"
    }
];
const mCardList2 = [
    {
        title: "AI生图",
        desc: "支持生成各种风格的高质量图片",
        img: func_img_2_1.src,
        statBtnKey: "ai_image"
    },
    {
        title: "AI文字改写",
        desc: "重写、美化、扩写、缩写，并支持选择文字风格",
        img: func_img_2_2.src,
        statBtnKey: "ai_text"
    },
    {
        title: "智能设计",
        desc: "贴纸、花字、多种元素随心设计",
        img: func_img_2_3.src,
        statBtnKey: "smart_design"
    }
];

// EXTERNAL MODULE: ./src/pageComponents/mobileHome/components/cardModule/index.module.css
var cardModule_index_module = __webpack_require__(90696);
var cardModule_index_module_default = /*#__PURE__*/__webpack_require__.n(cardModule_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/mobileHome/components/cardModule/index.tsx



const CardModule = (param)=>{
    let { cardList , title  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (cardModule_index_module_default()).cardWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cardModule_index_module_default()).cardTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (cardModule_index_module_default()).cardList,
                children: cardList.map((item)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (cardModule_index_module_default()).cardItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.img,
                                alt: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (cardModule_index_module_default()).cardItemTitle,
                                children: item.title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (cardModule_index_module_default()).cardItemDesc,
                                children: item.desc
                            })
                        ]
                    }, item.title))
            })
        ]
    });
};
/* harmony default export */ const cardModule = (CardModule);

// EXTERNAL MODULE: ./src/pageComponents/mobileHome/components/customModule/index.module.css
var customModule_index_module = __webpack_require__(21534);
var customModule_index_module_default = /*#__PURE__*/__webpack_require__.n(customModule_index_module);
;// CONCATENATED MODULE: ./src/assets/images/custom-img-1.png
/* harmony default export */ const custom_img_1 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/custom-img-1.e37c1cd7.png","height":400,"width":543,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAeUlEQVR42i3M4QrDIAwE4L7/Y26wUaZWjSa2K1498cdByH3JpnbtRxSkrD2JYWXMilJPt1U98Xp/4ENGLoYjVcSsSDMVBLfzicVYGKzdvBwxZNE+gdofPy/47gFSL/ijwPkIKY2Aus0PIY4iCAFDAIJ9gU6wIGcC9wAsDrf5fORu5QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/custom-img-2.png
/* harmony default export */ const custom_img_2 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/custom-img-2.37f903ac.png","height":400,"width":543,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAe0lEQVR42j3N4QrDMAgE4L7/i24d3VhTozEab/pjFQ5EPrmts+5DDWYrpjmmrUrozH36sSWA+0pgYFGcjdEuhnmgJsH0P5ChIOqV/DasteIGIgzqgtdX8Px0NGKMIQW0ukpD1BMwHm9C7XUrsBfKRFVIJ1ztjDEmiPX4AW/kutk+CECXAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/custom-img-3.png
/* harmony default export */ const custom_img_3 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/custom-img-3.9644b87e.png","height":400,"width":543,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAtElEQVR42h3My2rCQABA0fn/jyhdlELpixKRtmJroZC4UVBQUPAFihFJJmYyj2Scq7g7qyOsa1IIAKFQmuKkbgawzh+FUg2DuGCY5KySIbs0p5d06fx9UqoKIXPrnz5iHp//6UfvjKdL2l8tonYLKctwHWo/2neI5xGvPy/cvT2QZQesKXDOBWGMZzbNWcy2bLZrJrJH9/ebeHSPrjOEsXWqTUVZVuHkJNJl+OYc6rNGW3O8AGIErkIhEaflAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/custom-img-4.png
/* harmony default export */ const custom_img_4 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/custom-img-4.63c79668.png","height":400,"width":543,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAxklEQVR42h3HLavCYBiH8f+9F8cpg3M2xgGDIGIyiAoaBDX5aSx+BpPBINisBoPNIOJX0CgOX5Jl4BMmTJx7Hm9xV/lx0XqzCnz/6OnWk9udFuWzNTziF5sGkUYQxmF/8abzHmQM+neXcDyCkhZZGcDQlEPhPZLn80mfLQawfwpgdpFhhWo3Qj5XZzCzPPhHBsCVciPVRDF1PBm9NfWGniQJvpWaAVZ7oD+8ps/SJIpfKhDi5u22O7Z/TbIdIAqJQyHJcf/EB04QVLqKlEFoAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/pageComponents/mobileHome/components/customModule/index.tsx







const CustomModule = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (customModule_index_module_default()).customModule,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (customModule_index_module_default()).customModuleTitle,
                children: "内容/模板均可自定义，生成更合心意"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (customModule_index_module_default()).customModuleContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_1.src,
                                alt: "custom-img-1",
                                width: 140,
                                height: 104
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可修改内容大纲"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_2.src,
                                alt: "custom-img-2",
                                width: 140,
                                height: 104
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可选择PPT页数"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_3.src,
                                alt: "custom-img-3",
                                width: 140,
                                height: 104
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可选任意风格模板"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_4.src,
                                alt: "custom-img-4",
                                width: 140,
                                height: 104
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可切换单页布局样式"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const customModule = (/*#__PURE__*/react.memo(CustomModule));

// EXTERNAL MODULE: ./src/pageComponents/mobileHome/components/scene/index.module.css
var scene_index_module = __webpack_require__(7949);
var scene_index_module_default = /*#__PURE__*/__webpack_require__.n(scene_index_module);
;// CONCATENATED MODULE: ./src/assets/images/m-scene-icon-1.png
/* harmony default export */ const m_scene_icon_1 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-scene-icon-1.86592353.png","height":121,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAq0lEQVR42h3JwW4BURSA4f8cd2o0nVZi040m7Qt04ZW9gr2FYEe8gYwhCBliDObOPRLf9pOw7i+BtqgLq2JFEid8RW0zXzkR2TngBwAJuBOcs5yPbkSjFWMhJAoYiFHfbLNu2nTUsVvhDfeahwNEIoUqJj188/sPXq/cL55mHFBR5brPSecZf/cJ3ceQxeDIdvsJzqujoeW59K28PjFOPdms4v2tsl6nFGotnn1KTen0KFecAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/m-scene-icon-2.png
/* harmony default export */ const m_scene_icon_2 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-scene-icon-2.92236939.png","height":121,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAxElEQVR42hXBPU4CURiG0ee94yiBQcdIQWJiiGhsrDSuQXfAJtyChYuws6OzsrCyNcHCCBVTAKGhhIIMTPgZuB/hHH0kvusCXWRpmv99NfXw1KB0VsFvzAnNnJmvhyHRIOmcpq/Pse+1Yg8x2LFh505y620Ow6Rjt4/YUenEECYwwNxhQer//zD9bareeFPl8kq2RWZoz+FxWmfUatcEUUw1nNB6f8HmYwjgIM/Jqjf3xXKwscVspPb3J3fRnEKxzNKz2gGGkktJrbVL1QAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/m-scene-icon-3.png
/* harmony default export */ const m_scene_icon_3 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-scene-icon-3.6051fa7b.png","height":121,"width":168,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAYAAAD+Bd/7AAAAxElEQVR42g3KywoBURzH8fNMNt7DC7BX3sDSTlmIFGWhJJKSy8w5co00LoUNuc24K5mhqGny/zmLz+L368sEGRtOxruBy7N61sx8OmTWP0tT4PiSv8EE6RA/CWcolwnUdAzc3sp9ggzAFFxtCRIN91MSSoP4bkAq6SQDYuN7xd7PAxhZLSijFhI+L8q9Anq4QeAAtlJdTudYwWydwyIbQTEcRWpQQvDaR83Zgultt6U9OYy8nx4BD3i5hEy3BtaMI3nTvn+uEZ2PU1KYbQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./src/assets/images/m-scene-icon-4.png
/* harmony default export */ const m_scene_icon_4 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-scene-icon-4.e5238ff1.png","height":121,"width":271,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAfUlEQVR42gWAsQ7BUBRAz33vVlIhoSqxGEy+wOZv/YRdTJ2sYi0RAwlpmrbvXhE7VQ0iIwnq7eVMXG/JigLMBPcuiEhO30Us6W/+0JTftNGZ3qeriJKru+GvJ0P5ZrI50n5LPtmOMVMYDMXpZLnIkNqr60FSEvax9qAmEPo/pfgw84K7aSkAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/assets/images/m-scene-icon-5.png
/* harmony default export */ const m_scene_icon_5 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/m-scene-icon-5.c85dc629.png","height":121,"width":269,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAAgUlEQVR4nA3AwQ7BQBQF0HvbmekoEh/A2sSXWgn/JJVY2thYWCoLiVa1dN7Tw6LbfhJn/PtUSpZlNMsZpI8YkKotD91OxCnt+QVLjzqk8JVAjEF0ibD4bdRojuo4h7U5puGJ5tIgWZVQ68B9v64nVfDuGsTGkhh9cV/clOMHGdP2D/f6NjVbIR7+AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":4});
;// CONCATENATED MODULE: ./src/pageComponents/mobileHome/components/scene/index.tsx








const Scene = ()=>{
    const list = [
        {
            title: "职场办公",
            descs: [
                "运营转正述职报告",
                "产品经理季度总结",
                "互联网AIGC应用领域的行业分析报告"
            ],
            img: m_scene_icon_1.src,
            color: "#FFFAEE",
            fill: "#F9D674"
        },
        {
            title: "人事行政",
            descs: [
                "公司秋季团建方案",
                "新员工入职培训",
                "公司管理制度培训"
            ],
            img: m_scene_icon_2.src,
            color: "#F4FAFF",
            fill: "#ABD7FF"
        },
        {
            title: "教师学生",
            descs: [
                "新学期家长会课件",
                "大学生职业生涯规划",
                "大学生校园艺术节活动方案"
            ],
            img: m_scene_icon_3.src,
            color: "#F3FCFB",
            fill: "#BBFFE2"
        },
        {
            title: "营销策划",
            descs: [
                "双11商场线下促销活动",
                "美妆产品活动推广方案"
            ],
            img: m_scene_icon_4.src,
            color: "#FFF4F4",
            fill: "#FFC4CC"
        },
        {
            title: "医疗医护",
            descs: [
                "秋冬如何预防流感分享",
                "医疗卫生常识科普"
            ],
            img: m_scene_icon_5.src,
            color: "#F3FFE6",
            fill: "#C7FB91"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (scene_index_module_default()).scene,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (scene_index_module_default()).sceneTitle,
                children: "覆盖多场景 满足多人群PPT需求"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (scene_index_module_default()).sceneContent,
                children: list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (scene_index_module_default()).sceneContentItem,
                        style: {
                            backgroundColor: item.color
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (scene_index_module_default()).sceneContentItemTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (scene_index_module_default()).sceneContentItemImg,
                                        src: item.img,
                                        alt: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (scene_index_module_default()).sceneContentItemDesc,
                                children: item.descs.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: item
                                    }, "desc-".concat(idx)))
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ const scene = (/*#__PURE__*/react.memo(Scene));

// EXTERNAL MODULE: ./src/pageComponents/mobileHome/components/marquee/index.module.css
var marquee_index_module = __webpack_require__(99992);
var marquee_index_module_default = /*#__PURE__*/__webpack_require__.n(marquee_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/mobileHome/components/marquee/index.tsx



const Marquee = ()=>{
    const listOne = [
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new1.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new2.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new3.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new4.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new5.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new28.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new7.png",
        "https://xiuxiupro-material-center.meitudata.com/material/image/6761623d764052236.webp",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new10.png",
        "https://xiuxiupro-material-center.meitudata.com/material/image/67616212833a34738.webp",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new11.png"
    ];
    const listTwo = [
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new12.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new13.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new14.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new15.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new6.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new17.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new18.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new19.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new20.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new21.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new22.png"
    ];
    const listThree = [
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new23.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new24.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new25.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new26.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new27.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new16.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new29.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new30.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new31.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new32.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new33.png"
    ];
    const renderList = (list)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (marquee_index_module_default()).inner,
                    children: list.map((v, idx)=>{
                        return(// eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (marquee_index_module_default()).item,
                            width: 144,
                            height: 80,
                            loading: "lazy",
                            src: v,
                            alt: "template-".concat(idx)
                        }, "".concat(v, "-first")));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (marquee_index_module_default()).inner,
                    children: list.map((v, idx)=>{
                        return(// eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (marquee_index_module_default()).item,
                            width: 144,
                            height: 80,
                            loading: "lazy",
                            src: v,
                            alt: "template-second-".concat(idx)
                        }, "".concat(v, "-second")));
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (marquee_index_module_default()).marquee,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (marquee_index_module_default()).marqueeTitle,
                children: "提供风格多样的高级感PPT模板"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (marquee_index_module_default()).marqueeContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (marquee_index_module_default()).marqueeContentItem,
                        children: renderList(listOne)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((marquee_index_module_default()).marqueeContentItem, " ").concat((marquee_index_module_default()).marqueeContentItemRight),
                        children: renderList(listTwo)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (marquee_index_module_default()).marqueeContentItem,
                        children: renderList(listThree)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const marquee = (/*#__PURE__*/react.memo(Marquee));

// EXTERNAL MODULE: ./node_modules/clipboard-polyfill/dist/es6/clipboard-polyfill.es6.js
var clipboard_polyfill_es6 = __webpack_require__(16824);
// EXTERNAL MODULE: ./node_modules/antd/es/message/index.js + 5 modules
var message = __webpack_require__(66436);
// EXTERNAL MODULE: ./node_modules/antd/es/message/style/css.js
var css = __webpack_require__(74689);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/utils/index.ts
var utils = __webpack_require__(16598);
;// CONCATENATED MODULE: ./src/pageComponents/mobileHome/index.tsx




















const WxMask = dynamic_default()(()=>__webpack_require__.e(/* import() */ 278).then(__webpack_require__.bind(__webpack_require__, 70278)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(70278)
            ]
    },
    ssr: false
});
const Mobile = ()=>{
    const videoRef = (0,react.useRef)(null);
    const [wxMaskVisible, setWxMaskVisible] = (0,react.useState)(false);
    const downloadLink = (0,utils/* isAndroid */.Dt)() ? "https://releases-cicity.meitu.com/hosted/apk/d/d6p3e4z6cdipejygakqk5acmhf/官网/美图设计室_正式版.apk" : "https://apps.apple.com/cn/app/hai-bao-gong-chang/id875654777";
    (0,react.useEffect)(()=>{
        (0,mtstat/* statTrack */.SF)("ai_create_show", {
            ppt_home_page: "landing_page"
        });
    }, []);
    (0,react.useEffect)(()=>{
        // 监听video的播放暂停
        const video = videoRef.current;
        if (video) {
            video.addEventListener("play", ()=>{
                (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                    click_type: "video"
                });
            });
        }
        return ()=>{
            if (video) {
                video.removeEventListener("play", ()=>{});
            }
        };
    }, []);
    const handleCopyLink = async ()=>{
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "h5_copy_url"
        });
        clipboard_polyfill_es6/* writeText */.nx("https://www.designkit.cn/ppt").then(()=>{
            message/* default.success */.ZP.success("复制成功");
        }, ()=>{
            message/* default.error */.ZP.error("复制失败");
        });
    };
    const handleDownload = async ()=>{
        const openApp = (await __webpack_require__.e(/* import() */ 1970).then(__webpack_require__.bind(__webpack_require__, 65637))).default;
        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
            click_type: "h5_download_app"
        });
        if ((0,utils/* isWeiXin */.qW)() || (0,utils/* isQQ */.GP)()) {
            setWxMaskVisible(true);
        } else {
            openApp("xdesign", {
                scheme: "mthbp://webview?show_shareButton=true&hideHeader=false&url=".concat(encodeURIComponent("".concat((0,constants/* getPPTUrl */.hg)(), "/workspace"))),
                download: downloadLink
            });
            ;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: constants/* TITLE */.R
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: constants/* HOME_DESCRIPTION */.jN
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: constants/* HOME_KEYWORDS */.e3
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.designkit.cn/ppt/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).mobile,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (index_module_default()).header,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: logo/* default.src */.Z.src,
                            alt: "logo",
                            width: 134,
                            height: 18
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).title,
                        children: [
                            "下载APP或打开电脑端输入",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            "一句话生成",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: (index_module_default()).tag,
                                children: "LivePPT"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (index_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).videoTitle,
                                        children: "AI生成高质量PPT"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (index_module_default()).videoWrap,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                            className: (index_module_default()).video,
                                            ref: videoRef,
                                            src: "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/video-new3.mp4",
                                            autoPlay: true,
                                            muted: true,
                                            loop: true,
                                            playsInline: true,
                                            controls: true,
                                            "x5-playsinline": "true",
                                            "webkit-playsinline": "true",
                                            "x5-video-orientation": "portraint"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_module, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cardModule, {
                                cardList: mCardList,
                                title: "多种方式生成PPT，更灵活"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(customModule, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(cardModule, {
                                cardList: mCardList2,
                                title: "文字/图片可AI编辑，智能设计更高效"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(scene, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(marquee, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default()).footer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (index_module_default()).copyLink,
                        onClick: handleCopyLink,
                        children: "复制链接"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        className: (index_module_default()).download,
                        onClick: handleDownload,
                        children: "下载APP"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(WxMask, {
                show: wxMaskVisible,
                onClose: ()=>setWxMaskVisible(false)
            })
        ]
    });
};
/* harmony default export */ const mobileHome = (Mobile);

// EXTERNAL MODULE: ./src/pageComponents/webHome/index.module.css
var webHome_index_module = __webpack_require__(60426);
var webHome_index_module_default = /*#__PURE__*/__webpack_require__.n(webHome_index_module);
// EXTERNAL MODULE: ./src/components/webHeader/index.tsx + 2 modules
var webHeader = __webpack_require__(2014);
// EXTERNAL MODULE: ./src/store/index.ts + 1 modules
var store = __webpack_require__(29358);
// EXTERNAL MODULE: ./node_modules/next/script.js
var script = __webpack_require__(4298);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
// EXTERNAL MODULE: ./src/assets/images/banner-arrow.png
var banner_arrow = __webpack_require__(7401);
// EXTERNAL MODULE: ./src/layout/footer/index.module.css
var footer_index_module = __webpack_require__(18809);
var footer_index_module_default = /*#__PURE__*/__webpack_require__.n(footer_index_module);
;// CONCATENATED MODULE: ./src/assets/images/footer-logo.svg
/* harmony default export */ const footer_logo = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/footer-logo.8be1c264.svg","height":73,"width":234});
;// CONCATENATED MODULE: ./src/layout/footer/index.tsx





const Footer = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("footer", {
        className: (footer_index_module_default()).footer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (footer_index_module_default()).inner,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (footer_index_module_default()).left,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: footer_logo.src,
                            alt: "美图设计室",
                            width: 234,
                            height: 73
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (footer_index_module_default()).right,
                        children: footerInfo.cols.map((col, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (footer_index_module_default()).col,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_index_module_default()).title,
                                        children: col.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (footer_index_module_default()).content,
                                        children: col.list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: (footer_index_module_default()).item,
                                                href: item.url,
                                                target: "_blank",
                                                rel: "noreferrer",
                                                onClick: (e)=>{
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    window.open(item.url);
                                                    (0,mtstat/* statTrack */.SF)("bottom_nav_click", {
                                                        class: "mtsjs_web",
                                                        region: col.mtValue,
                                                        value: item.title
                                                    });
                                                },
                                                children: item.title
                                            }, "link_".concat(index)))
                                    })
                                ]
                            }, "col_".concat(idx)))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (footer_index_module_default()).copyright,
                dangerouslySetInnerHTML: {
                    __html: "\xa9 ".concat(new Date().getFullYear()).concat(footerInfo.copyright)
                }
            })
        ]
    });
};
/* harmony default export */ const footer = (Footer);

// EXTERNAL MODULE: ./src/utils/query.ts
var utils_query = __webpack_require__(20695);
// EXTERNAL MODULE: ./src/pageComponents/webHome/components/module/index.module.css
var components_module_index_module = __webpack_require__(47187);
var components_module_index_module_default = /*#__PURE__*/__webpack_require__.n(components_module_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webHome/components/module/index.tsx




const module_Module = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (components_module_index_module_default()).module,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (components_module_index_module_default()).moduleTitle,
                    children: [
                        "动态模式全新推出，让PPT汇报更生动",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: svip_badage/* default.src */.Z.src,
                            alt: "badge",
                            width: 30,
                            className: (components_module_index_module_default()).badge
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (components_module_index_module_default()).animation,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (components_module_index_module_default()).animationInner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: (components_module_index_module_default()).animationItem,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (components_module_index_module_default()).animationItemFlex,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (components_module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/6761622898f645678.webp)"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (components_module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/6761623d764052236.webp)"
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (components_module_index_module_default()).animationItemFlex,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (components_module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/6761625021e239641.webp)"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (components_module_index_module_default()).animationItemImg,
                                                    style: {
                                                        backgroundImage: "url(https://xiuxiupro-material-center.meitudata.com/material/image/67628f7d8b6de8861.webp)"
                                                    }
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (components_module_index_module_default()).animationSubTitle,
                                    children: "丰富动态模板任你选择，匹配更多汇报场景"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (components_module_index_module_default()).animationInner,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (components_module_index_module_default()).animationVideoItem,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                        src: "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/0a0caf0653023a7c0b090f82b87a8ed9 (1).mp4",
                                        autoPlay: true,
                                        muted: true,
                                        loop: true,
                                        playsInline: true,
                                        "webkit-playsinline": "true",
                                        "x5-playsinline": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (components_module_index_module_default()).animationSubTitle,
                                    children: "提供多种动画演示效果，一键开启吸睛汇报"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const webHome_components_module = (/*#__PURE__*/react.memo(module_Module));

// EXTERNAL MODULE: ./src/pageComponents/webHome/components/cardModule/index.module.css
var components_cardModule_index_module = __webpack_require__(94528);
var components_cardModule_index_module_default = /*#__PURE__*/__webpack_require__.n(components_cardModule_index_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/@meitu/xdesign-icon-font/dist/IconFont.js + 2 modules
var IconFont = __webpack_require__(15328);
;// CONCATENATED MODULE: ./src/pageComponents/webHome/components/cardModule/index.tsx






const cardModule_CardModule = (param)=>{
    let { cardList , title  } = param;
    const [cur, setCur] = (0,react.useState)(0);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (components_cardModule_index_module_default()).cardWrap,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (components_cardModule_index_module_default()).cardTitle,
                children: title
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (components_cardModule_index_module_default()).cardList,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (components_cardModule_index_module_default()).cardListLeft,
                        children: cardList.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classnames_default()((components_cardModule_index_module_default()).cardItem, {
                                    [(components_cardModule_index_module_default()).cardItemActive]: cur === index
                                }),
                                onMouseEnter: ()=>{
                                    setCur(index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (components_cardModule_index_module_default()).cardItemText,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (components_cardModule_index_module_default()).cardItemTitle,
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (components_cardModule_index_module_default()).cardItemDesc,
                                                children: item.desc
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                        className: (components_cardModule_index_module_default()).cardItemBtn,
                                        href: item.url,
                                        onClick: (e)=>{
                                            e.preventDefault();
                                            e.stopPropagation();
                                            (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                click_type: "intro_create",
                                                intro_create_button: item.statBtnKey
                                            });
                                            setTimeout(()=>{
                                                window.location.href = item.url;
                                            }, 100);
                                        },
                                        children: [
                                            "生成",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFont/* default */.Z, {
                                                fontSize: 14,
                                                className: (components_cardModule_index_module_default()).cardItemBtnIcon,
                                                name: "ForwardArrowBold",
                                                color: "#fff"
                                            })
                                        ]
                                    })
                                ]
                            }, item.statBtnKey))
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (components_cardModule_index_module_default()).cardListRight,
                        children: cardList.map((item, index)=>// eslint-disable-next-line @next/next/no-img-element
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: item.img,
                                className: classnames_default()((components_cardModule_index_module_default()).cardImg, {
                                    [(components_cardModule_index_module_default()).cardImgActive]: index === cur
                                }),
                                alt: ""
                            }, item.title))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const components_cardModule = (cardModule_CardModule);

// EXTERNAL MODULE: ./src/pageComponents/webHome/components/customModule/index.module.css
var components_customModule_index_module = __webpack_require__(43057);
var components_customModule_index_module_default = /*#__PURE__*/__webpack_require__.n(components_customModule_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webHome/components/customModule/index.tsx







const customModule_CustomModule = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (components_customModule_index_module_default()).customModule,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (components_customModule_index_module_default()).customModuleTitle,
                children: "内容/模板均可自定义，生成更合心意"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (components_customModule_index_module_default()).customModuleContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (components_customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_1.src,
                                alt: "custom-img-1",
                                width: 270
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (components_customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可修改内容大纲"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (components_customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_2.src,
                                alt: "custom-img-2",
                                width: 270
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (components_customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可选择PPT页数"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (components_customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_3.src,
                                alt: "custom-img-3",
                                width: 270
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (components_customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可选任意风格模板"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (components_customModule_index_module_default()).customModuleContentItem,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: custom_img_4.src,
                                alt: "custom-img-4",
                                width: 270
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (components_customModule_index_module_default()).customModuleContentItemTitle,
                                children: "可切换单页布局样式"
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const components_customModule = (/*#__PURE__*/react.memo(customModule_CustomModule));

// EXTERNAL MODULE: ./src/pageComponents/webHome/components/scene/index.module.css
var components_scene_index_module = __webpack_require__(31472);
var components_scene_index_module_default = /*#__PURE__*/__webpack_require__.n(components_scene_index_module);
;// CONCATENATED MODULE: ./src/assets/images/scene-icon-1.png
/* harmony default export */ const scene_icon_1 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/scene-icon-1.f6f8343a.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA90lEQVR42hWMzUoCUQCF72v0COMztap9RO1dBSUYJqIZFuL8qCBhCCYFVrddtLCykAIhiZk7WYyBUsyl6WtmceBwfj4BiMizDFRdfruHeqEqGtWQkWcagBAo2/jz7ID3Jv4oz+QuA8ohyWIZyUDGBnw7nN5m6Bd2cPvZkI8mkWtJEZcavwFTi6t2i2rxnK9RKznEFEcLlKN/J1Xm9xWG9TJeN8/rSZnHsx58WlrEKDkbFhk4m+Hp9hrH6VVyy+nw5bIDM1MK6KXeBqVAPRTYL2VZWq9Qqx3wMz4KWLQNAQhrd8WYj2vy+SKnu+aWfrrekzedjRQg/gHbYset18/88wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/scene-icon-2.png
/* harmony default export */ const scene_icon_2 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/scene-icon-2.35a47894.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAABAElEQVR42iXNvUrDUBjG8Re8BK/idPAidHRx6dLFURDdFB0UBwvqElLqR0TqVxRrkwNpEXQoxrMJgqDWHFPR0tI50KFDTkifJukL/+338lC1FVES4z6EJaEsP0lC1LwRo/SqX4rZPoLrtwHyiyvQzCZ4G0hAkKH7ViScf2Dnyg0XiFDZWIL5PgztnwwJqnlQXI5Q2NSxNTeF2/IR7jzAkhlQlHyr3cojZmemcWOU8fzyCjud+I4noPEHsXfmYLkwH56UNPR7v9gvGaF+UYfThiAu49y52wmOzQdcGodomKfQVvOo86fAGYCRiJHGioYt9OK2OlhfU033Q3x2oxwR0Rix6baGmtRBOgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/scene-icon-3.png
/* harmony default export */ const scene_icon_3 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/scene-icon-3.26c09253.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA/UlEQVR42iWMwUoCURiF7+tcNz1HkC8QbYRoWbt8gGgVtDHKwE1BBJKjNkXOvTf0SmHRtAgrhWDujDm1ctq0aC7m8R88cOD/Od85LJPEiItZpCXGVuKL/KnFf8jJFM6i7EgkYlyPH1FzSmj9fYCgREwNJyDU1AYBqRf78E4qENMwJQDZKvNoUiGEQIyHQQ83jUu0hm36owyw7CWoWOOvwZ94cHsKB6sFNJ5cdPANhZFl71dLuvPTxdvraWpKRbjHhyjfVdONQKL2O9Bscs9y3eFFYvZWEBQ3UXcUyuoWrH2UsPo+Zws53Kwv6+etgj3b3rU751Wd7zdz+X6TzQGhMbwlxN0J/wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/scene-icon-4.png
/* harmony default export */ const scene_icon_4 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/scene-icon-4.a869d314.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA+0lEQVR42iWPvU4CQRhFv9cZXsTKB7CzMhYWJr4AlQn0djY2WmhijAouamTY3dnZ3VFcFTGaSEQsHfwBzQwwlyXc5FSnuYdmA5fMRbfcRZmFn1oEKR+HTZZD5K4Ec+JGo+oBR4dw4hrOV0Aj1rioM3KB4pB3GJY2Ta+4msssl9L8x48wSZvTpFa3kE18V8p4P1sB0r2cJ8Sij/5Lx5I7vbSjYAt/DcJIEXoHhLf7CM+dT+hIWEJyzAfeOj6qnmlVauiehBh4u+Y3jDH2FafhORUmfF/vlA1o4QvbxVdAzn4oDV+xeWb2wEobP3xpMbJry23b9VociSggETQFB9HD/1T4O0wAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/assets/images/scene-icon-5.png
/* harmony default export */ const scene_icon_5 = ({"src":"https://pc.meitudata.com/live-ppt/_next/static/media/scene-icon-5.6b92ce43.png","height":96,"width":96,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAYAAADED76LAAAA9klEQVR42hWMzUrDQBSF7+ukj6Qv4bIg7hVbTWIUxI2u3FiKFEQRmk5MZtLU1qa0ijEg/hQRJIqL6owJx5kL3+HC+aHwd5s0VgKP9b421NWioUTpMq5si8yx74Y1gFe071exv7KE7mwdAg64tAthQvphAh78fl0+H9SRT22ElSO1CQ0jLYqXLgZyC7m7jNHDGiI4EFKvaI+M8KqJ89tdtA+PEU99iB8PUbkJ/mcCZZPdvJ3h4qQjW51LRL0h4okvh9UR+GKHUfp5WsuzuyLhIfqhbgddZEmA93lapK8ji+YvTwbrOo7YZDxWj9lMFcke+whaNSKifyZIwJMx3KXnAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./src/pageComponents/webHome/components/scene/index.tsx








const scene_Scene = ()=>{
    const list = [
        {
            title: "职场办公",
            descs: [
                "运营转正述职报告",
                "产品经理季度工作总结",
                "互联网AIGC应用领域的行业分析报告"
            ],
            img: scene_icon_1.src,
            color: "#FFFAEE",
            fill: "#F9D674"
        },
        {
            title: "人事行政",
            descs: [
                "公司秋季团建方案",
                "新员工入职培训",
                "公司管理制度培训"
            ],
            img: scene_icon_2.src,
            color: "#F4FAFF",
            fill: "#ABD7FF"
        },
        {
            title: "教师学生",
            descs: [
                "新学期家长会课件",
                "大学生职业生涯规划",
                "大学生校园艺术节活动方案"
            ],
            img: scene_icon_3.src,
            color: "#F3FCFB",
            fill: "#BBFFE2"
        },
        {
            title: "营销策划",
            descs: [
                "双11商场线下促销活动方案",
                "美妆产品活动推广方案"
            ],
            img: scene_icon_4.src,
            color: "#FFF4F4",
            fill: "#FFC4CC"
        },
        {
            title: "医疗医护",
            descs: [
                "秋冬如何预防流感分享",
                "医疗卫生常识科普"
            ],
            img: scene_icon_5.src,
            color: "#F3FFE6",
            fill: "#C7FB91"
        }
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (components_scene_index_module_default()).scene,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (components_scene_index_module_default()).sceneTitle,
                children: "覆盖多场景 满足多人群PPT需求"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (components_scene_index_module_default()).sceneContent,
                children: list.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (components_scene_index_module_default()).sceneContentItem,
                        style: {
                            backgroundColor: item.color
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                width: "24",
                                height: "22",
                                viewBox: "0 0 24 22",
                                fill: "none",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M0 20L3.62416 10.96H1.61074V0H11.1946V12.16L2.89933 22L0 20ZM12.8054 20L16.4295 10.96H14.4161V0H24V12.16L15.7047 22L12.8054 20Z",
                                    fill: item.fill
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (components_scene_index_module_default()).sceneContentItemTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (components_scene_index_module_default()).sceneContentItemImg,
                                        src: item.img,
                                        alt: item.title
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        children: item.title
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                className: (components_scene_index_module_default()).sceneContentItemDesc,
                                children: item.descs.map((item, idx)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                        children: item
                                    }, "desc-".concat(idx)))
                            })
                        ]
                    }, index))
            })
        ]
    });
};
/* harmony default export */ const components_scene = (/*#__PURE__*/react.memo(scene_Scene));

// EXTERNAL MODULE: ./src/pageComponents/webHome/components/marquee/index.module.css
var components_marquee_index_module = __webpack_require__(99101);
var components_marquee_index_module_default = /*#__PURE__*/__webpack_require__.n(components_marquee_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webHome/components/marquee/index.tsx



const marquee_Marquee = ()=>{
    const listOne = [
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new1.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new2.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new3.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new4.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new5.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new28.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new7.png",
        "https://xiuxiupro-material-center.meitudata.com/material/image/6761623d764052236.webp",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new10.png",
        "https://xiuxiupro-material-center.meitudata.com/material/image/67616212833a34738.webp",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new11.png"
    ];
    const listTwo = [
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new12.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new13.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new14.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new15.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new6.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new17.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new18.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new19.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new20.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new21.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new22.png"
    ];
    const listThree = [
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new23.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new24.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new25.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new26.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new27.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new16.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new29.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new30.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new31.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new32.png",
        "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/new33.png"
    ];
    const renderList = (list)=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (components_marquee_index_module_default()).inner,
                    children: list.map((v, idx)=>{
                        return(// eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (components_marquee_index_module_default()).item,
                            width: 374,
                            height: 208,
                            loading: "lazy",
                            src: v,
                            alt: "template-".concat(idx)
                        }, "".concat(v, "-first")));
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (components_marquee_index_module_default()).inner,
                    children: list.map((v, idx)=>{
                        return(// eslint-disable-next-line @next/next/no-img-element
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            className: (components_marquee_index_module_default()).item,
                            width: 374,
                            height: 208,
                            loading: "lazy",
                            src: v,
                            alt: "template-second-".concat(idx)
                        }, "".concat(v, "-second")));
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (components_marquee_index_module_default()).marquee,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (components_marquee_index_module_default()).marqueeTitle,
                children: "提供风格多样的高级感PPT模板"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (components_marquee_index_module_default()).marqueeContent,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (components_marquee_index_module_default()).marqueeContentItem,
                        children: renderList(listOne)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat((components_marquee_index_module_default()).marqueeContentItem, " ").concat((components_marquee_index_module_default()).marqueeContentItemRight),
                        children: renderList(listTwo)
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (components_marquee_index_module_default()).marqueeContentItem,
                        children: renderList(listThree)
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ const components_marquee = (/*#__PURE__*/react.memo(marquee_Marquee));

// EXTERNAL MODULE: ./src/pageComponents/webHome/components/experienceEntrance/index.module.css
var experienceEntrance_index_module = __webpack_require__(19142);
var experienceEntrance_index_module_default = /*#__PURE__*/__webpack_require__.n(experienceEntrance_index_module);
;// CONCATENATED MODULE: ./src/pageComponents/webHome/components/experienceEntrance/index.tsx






const ExperienceEntrance = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (experienceEntrance_index_module_default()).experienceEntrance,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (experienceEntrance_index_module_default()).inner,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (experienceEntrance_index_module_default()).title,
                    children: "全新的PPT生成方式"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (experienceEntrance_index_module_default()).desc,
                    children: "革新生成技术，一键创作精美PPT，为你节省90%时间，让创意自由流淌。"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                    className: (experienceEntrance_index_module_default()).btn,
                    href: pptUrl,
                    onClick: (e)=>{
                        e.preventDefault();
                        e.stopPropagation();
                        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                            click_type: "intro_create",
                            intro_create_button: "start_experience"
                        });
                        setTimeout(()=>{
                            window.location.href = pptUrl;
                        }, 100);
                    },
                    children: [
                        "开始体验",
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(IconFont/* default */.Z, {
                            name: "ArrowRightBold",
                            color: "#fff",
                            fontSize: 22,
                            className: (experienceEntrance_index_module_default()).btnIcon
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const experienceEntrance = (/*#__PURE__*/react.memo(ExperienceEntrance));

;// CONCATENATED MODULE: ./src/pageComponents/webHome/index.tsx






















const DeepSeekBtn = dynamic_default()(()=>__webpack_require__.e(/* import() */ 6885).then(__webpack_require__.bind(__webpack_require__, 46885)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(46885)
            ]
    },
    ssr: false
});
const PromotionComponent = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(7826), __webpack_require__.e(9895)]).then(__webpack_require__.bind(__webpack_require__, 85451)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(85451)
            ]
    },
    ssr: false
});
const OverseasAccessModal = dynamic_default()(// @ts-ignore
()=>Promise.all(/* import() */[__webpack_require__.e(6040), __webpack_require__.e(8034)]).then(__webpack_require__.bind(__webpack_require__, 66040)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(66040)
            ]
    },
    ssr: false
});
const Home = (props)=>{
    const defaultPageSize = "16-20页";
    const { isPersonal , initData  } = props;
    const isOpenDeepSeek = (0,store/* useStoreState */.Kw)((state)=>state.isOpenDeepSeek);
    const setIsOpenDeepSeek = (0,store/* useStoreActions */.WX)((actions)=>actions.setIsOpenDeepSeek);
    const videoRef = (0,react.useRef)(null);
    const [placeholderPrompt, setPlaceholderPrompt] = (0,react.useState)(initData.placeholder_prompt);
    const [keyword, setKeyword] = (0,react.useState)("");
    const query = (0,utils_query/* getQuery */.pm)();
    const handleClickDeepSeek = (active)=>{
        setIsOpenDeepSeek(active);
    };
    const keywordChangeHandle = (e)=>{
        const { value  } = e.target;
        if (value === keyword) return;
        setKeyword(value.trim());
        window.sessionStorage.setItem("pptKeyword", value.trim());
    };
    const handleJump = (word)=>{
        // TODO 跳转workbench
        const pptUrl = "".concat((0,constants/* getDesignHome */.y$)(), "/ppt/edit?from=ppt_landingpage");
        const from = (0,utils/* isMobile */.tq)() ? "h5" : "";
        const hb_position = query.hb_position || "";
        const hb_operation = query.hb_operation || "";
        // hb_position || hb_operation 是APP内嵌投放字段特有的
        const channel = hb_position || hb_operation ? "app" : query.channel || "";
        const tool_url = query.tool_url || "";
        const indtool_source = query.indtool_source || "";
        window.location.href = "".concat(pptUrl, "&ppt_home_page=landing_page&keyword=").concat(encodeURIComponent(word), "&pageSize=").concat(encodeURIComponent((0,utils/* isMobile */.tq)() ? "10-15页" : defaultPageSize)).concat(channel && (hb_position || hb_operation) ? "&channel=".concat(channel) : "", "&from=").concat(from, "&indtool_source=").concat(encodeURIComponent(indtool_source), "&tool_url=").concat(encodeURIComponent(tool_url), "&hb_operation=").concat(encodeURIComponent(hb_operation), "&hb_position=").concat(encodeURIComponent(hb_position), "&is_deepseek=").concat(isOpenDeepSeek ? "1" : "0");
    };
    // 免费生成大纲
    const freeCreate = async ()=>{
        if (!keyword) {
            setKeyword(placeholderPrompt);
            setTimeout(()=>{
                handleJump(placeholderPrompt);
            }, 0);
            return;
        }
        handleJump(keyword);
    };
    (0,react.useEffect)(()=>{
        (0,mtstat/* statTrack */.SF)("ai_create_show", {
            ppt_home_page: "landing_page"
        });
    }, []);
    (0,react.useEffect)(()=>{
        // 监听video的播放暂停
        const video = videoRef.current;
        if (video) {
            video.addEventListener("play", ()=>{
                (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                    click_type: "video"
                });
            });
        }
        return ()=>{
            if (video) {
                video.removeEventListener("play", ()=>{});
            }
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layout/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: constants/* TITLE */.R
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: constants/* HOME_DESCRIPTION */.jN
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "keywords",
                        content: constants/* HOME_KEYWORDS */.e3
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://public.static.meitudata.com/x-design/domain/mark-domain.js",
                async: true
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((script_default()), {
                src: "https://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (webHome_index_module_default()).home,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(webHeader/* default */.Z, {
                        isPersonal: isPersonal
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (webHome_index_module_default()).content,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (webHome_index_module_default()).title,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        className: (webHome_index_module_default()).tag,
                                        children: "LivePPT"
                                    }),
                                    "输入PPT主题",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "AI生成高质量PPT"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (webHome_index_module_default()).inputWrap,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        className: (webHome_index_module_default()).arrow,
                                        src: banner_arrow/* default.src */.Z.src,
                                        alt: "arrow",
                                        width: 63
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (webHome_index_module_default()).deepSeekBtn,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(DeepSeekBtn, {
                                            active: isOpenDeepSeek,
                                            onClick: handleClickDeepSeek
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (webHome_index_module_default()).inner,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                className: (webHome_index_module_default()).input,
                                                maxLength: 300,
                                                onChange: keywordChangeHandle,
                                                type: "text",
                                                value: keyword,
                                                onBlur: (e)=>{
                                                    if (keyword) {
                                                        (0,mtstat/* statTrack */.SF)("tools_click_ppt_home", {
                                                            click_type: "inputbox"
                                                        });
                                                    }
                                                },
                                                placeholder: initData.placeholder_text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                className: (webHome_index_module_default()).btn,
                                                onClick: freeCreate,
                                                children: "免费生成大纲"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (webHome_index_module_default()).video,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("video", {
                                    ref: videoRef,
                                    src: "https://public.static.meitudata.com/xiuxiu-pc/x-design/ppt/video-new3.mp4",
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    controls: true,
                                    "x5-playsinline": "true",
                                    "webkit-playsinline": "true",
                                    "x5-video-orientation": "portraint"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(webHome_components_module, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_cardModule, {
                                cardList: cardList,
                                title: "AI在线秒出PPT，多种生成方式更灵活"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_customModule, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_cardModule, {
                                cardList: cardList2,
                                title: "文字/图片可AI编辑，智能设计更高效"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_scene, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_marquee, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(experienceEntrance, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(OverseasAccessModal, {
                        track: mtstat/* statTrack */.SF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PromotionComponent, {
                        triggerPage: 8192
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(footer, {})
        ]
    });
};
/* harmony default export */ const webHome = (Home);

;// CONCATENATED MODULE: ./src/pages/home/index.tsx




const home_Home = (props)=>{
    const { isMobile , isPersonal , initData  } = props;
    return isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(mobileHome, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(webHome, {
        isPersonal: isPersonal,
        initData: initData
    });
};
var __N_SSP = true;
/* harmony default export */ const home = (home_Home);


/***/ }),

/***/ 56319:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
class EventBus {
    on(event, callback) {
        if (!this.events.has(event)) {
            this.events.set(event, new Set());
        }
        this.events.get(event).add(callback);
    }
    off(event, callback) {
        var ref;
        (ref = this.events.get(event)) === null || ref === void 0 ? void 0 : ref.delete(callback);
    }
    emit(event) {
        for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
            args[_key - 1] = arguments[_key];
        }
        var ref;
        (ref = this.events.get(event)) === null || ref === void 0 ? void 0 : ref.forEach((cb)=>cb(...args));
    }
    once(event, callback) {
        var _this = this;
        const onceWrapper = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            callback(...args);
            _this.off(event, onceWrapper);
        };
        this.on(event, onceWrapper);
    }
    clear(event) {
        if (event) {
            this.events.delete(event);
        } else {
            this.events.clear();
        }
    }
    constructor(){
        this.events = new Map();
    }
}
const event = new EventBus();
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (event);


/***/ }),

/***/ 74689:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _style_default_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35381);
/* harmony import */ var _style_default_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_style_default_css__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86303);
/* harmony import */ var _index_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_index_css__WEBPACK_IMPORTED_MODULE_1__);




/***/ }),

/***/ 30446:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"webHeader":"webHeader_webHeader__0R3uA","left":"webHeader_left__obtKs","right":"webHeader_right__y3Hed","createBtn":"webHeader_createBtn__FILei","createIcon":"webHeader_createIcon__nfGnP"};

/***/ }),

/***/ 18809:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer_footer__ZCL1v","inner":"footer_inner__CAz2F","left":"footer_left__TrrMY","right":"footer_right__DCwka","col":"footer_col__IM1St","title":"footer_title__sHjjC","content":"footer_content__WBef7","item":"footer_item__1A6Kw","copyright":"footer_copyright__No8VH"};

/***/ }),

/***/ 90696:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"cardModule_cardWrap__RNAnW","cardTitle":"cardModule_cardTitle__lECOd","cardList":"cardModule_cardList__azESG","cardItem":"cardModule_cardItem__8wDWq","cardItemTitle":"cardModule_cardItemTitle__JU_kK","cardItemDesc":"cardModule_cardItemDesc__nOuSJ"};

/***/ }),

/***/ 21534:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"customModule":"customModule_customModule__MdT7P","customModuleTitle":"customModule_customModuleTitle__QHyB0","customModuleContent":"customModule_customModuleContent__klNYi","customModuleContentItem":"customModule_customModuleContentItem__oBhso","customModuleContentItemTitle":"customModule_customModuleContentItemTitle__Jrz4F"};

/***/ }),

/***/ 99992:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"marquee":"marquee_marquee__h2Gnv","marqueeTitle":"marquee_marqueeTitle__PSN6L","marqueeContentItem":"marquee_marqueeContentItem__bPJko","marqueeContent":"marquee_marqueeContent___y_ov","inner":"marquee_inner__MVgJb","scroll-left":"marquee_scroll-left__kSd5R","item":"marquee_item__oOV5z","marqueeContentItemRight":"marquee_marqueeContentItemRight__nQhPQ","scroll-right":"marquee_scroll-right__v69hN"};

/***/ }),

/***/ 68253:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"module":"module_module__3C7IX","moduleTitle":"module_moduleTitle__yFa7L","badge":"module_badge__8D7Hk","animation":"module_animation__IAapa","animationItem":"module_animationItem__3TLIg","animationItemFlex":"module_animationItemFlex__yQtdQ","animationItemImg":"module_animationItemImg__T2r_9","animationVideoItem":"module_animationVideoItem___5a18","animationSubTitle":"module_animationSubTitle__DBLb5"};

/***/ }),

/***/ 7949:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"scene":"scene_scene__xwH8P","sceneTitle":"scene_sceneTitle__gQN7o","sceneContent":"scene_sceneContent__Bl3Ta","sceneContentItem":"scene_sceneContentItem__0ZGSG","sceneContentItemTitle":"scene_sceneContentItemTitle__qxA8c","sceneContentItemImg":"scene_sceneContentItemImg__FfBZ2","sceneContentItemDesc":"scene_sceneContentItemDesc__78UmO"};

/***/ }),

/***/ 23254:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"mobile":"mobileHome_mobile__KuBWy","header":"mobileHome_header__gcM_6","title":"mobileHome_title__icfaN","tag":"mobileHome_tag__gb39Q","content":"mobileHome_content__xJxtV","videoTitle":"mobileHome_videoTitle__xcwRm","videoWrap":"mobileHome_videoWrap__jkM7t","video":"mobileHome_video__Twn_7","footer":"mobileHome_footer__gv1ku","copyLink":"mobileHome_copyLink__aTL_G","download":"mobileHome_download__FHWWz"};

/***/ }),

/***/ 94528:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"cardWrap":"cardModule_cardWrap__SB0dr","cardTitle":"cardModule_cardTitle__7Hzth","cardList":"cardModule_cardList__tR5_V","cardListLeft":"cardModule_cardListLeft__GVGjJ","cardItem":"cardModule_cardItem__GzPTD","cardItemActive":"cardModule_cardItemActive__zjW1E","cardItemText":"cardModule_cardItemText__Rfn4l","cardItemTitle":"cardModule_cardItemTitle__9x8RG","cardItemDesc":"cardModule_cardItemDesc__mXT_J","cardItemBtn":"cardModule_cardItemBtn__zfkR8","cardItemBtnIcon":"cardModule_cardItemBtnIcon__HYFEz","cardListRight":"cardModule_cardListRight__YzTD8","cardImg":"cardModule_cardImg__71Y6D","cardImgActive":"cardModule_cardImgActive__ojsgr"};

/***/ }),

/***/ 43057:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"customModule":"customModule_customModule__3WHrU","customModuleTitle":"customModule_customModuleTitle__UqfdR","customModuleContent":"customModule_customModuleContent__QAKT5","customModuleContentItem":"customModule_customModuleContentItem__Ka1_Q","customModuleContentItemTitle":"customModule_customModuleContentItemTitle__t5RMZ"};

/***/ }),

/***/ 19142:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"experienceEntrance":"experienceEntrance_experienceEntrance__C4iym","inner":"experienceEntrance_inner__z9GO3","title":"experienceEntrance_title__JN2vT","desc":"experienceEntrance_desc___rzHQ","btn":"experienceEntrance_btn__n8REX","btnIcon":"experienceEntrance_btnIcon__jGLi8"};

/***/ }),

/***/ 99101:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"marquee":"marquee_marquee__H77Dt","marqueeTitle":"marquee_marqueeTitle__85bFU","marqueeContentItem":"marquee_marqueeContentItem__BBqu3","marqueeContent":"marquee_marqueeContent__o6GQj","inner":"marquee_inner__S4P34","scroll-left":"marquee_scroll-left__eOuMm","item":"marquee_item__vnZPU","marqueeContentItemRight":"marquee_marqueeContentItemRight__Ez40X","scroll-right":"marquee_scroll-right__wkX_7"};

/***/ }),

/***/ 47187:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"module":"module_module__EX9te","moduleTitle":"module_moduleTitle__I2RWw","badge":"module_badge__HzxXx","animation":"module_animation__LcngL","animationItem":"module_animationItem__cZfFS","animationItemFlex":"module_animationItemFlex__U5LjO","animationItemImg":"module_animationItemImg__A6xGN","animationVideoItem":"module_animationVideoItem__Ei0E0","animationSubTitle":"module_animationSubTitle__cfV93"};

/***/ }),

/***/ 31472:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"scene":"scene_scene__mouJ8","sceneTitle":"scene_sceneTitle__gFofK","sceneContent":"scene_sceneContent__0wrGk","sceneContentItem":"scene_sceneContentItem__Ppcz8","sceneContentItemTitle":"scene_sceneContentItemTitle__OpuGq","sceneContentItemImg":"scene_sceneContentItemImg__mnu31","sceneContentItemDesc":"scene_sceneContentItemDesc__TnlEB"};

/***/ }),

/***/ 60426:
/***/ ((module) => {

// extracted by mini-css-extract-plugin
module.exports = {"home":"webHome_home__9PMrn","title":"webHome_title__wCE_I","tag":"webHome_tag__Up5Bu","inputWrap":"webHome_inputWrap__nFlHa","arrow":"webHome_arrow__qQEyD","deepSeekBtn":"webHome_deepSeekBtn__aXBby","inner":"webHome_inner__LH2WM","input":"webHome_input__sxNn7","btn":"webHome_btn__s7L21","video":"webHome_video__YxNGx"};

/***/ }),

/***/ 86303:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 35381:
/***/ (() => {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 9008:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports = __webpack_require__(18158)


/***/ }),

/***/ 4298:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

module.exports =
   false
    ? 0
    : __webpack_require__(4110)


/***/ }),

/***/ 16824:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "nx": () => (/* binding */ writeText)
/* harmony export */ });
/* unused harmony exports ClipboardItem, read, readText, setDebugLog, suppressWarnings, write */
// src/clipboard-polyfill/ClipboardItem/data-types.ts
var TEXT_PLAIN = "text/plain";
var TEXT_HTML = "text/html";

// src/clipboard-polyfill/debug.ts
var debugLogImpl = (s) => {
};
function debugLog(s) {
  debugLogImpl(s);
}
function setDebugLog(logFn) {
  debugLogImpl = logFn;
}
var showWarnings = true;
function suppressWarnings() {
  showWarnings = false;
}
function shouldShowWarnings() {
  return showWarnings;
}
function warnOrLog() {
  (console.warn || console.log).apply(console, arguments);
}
var warn = warnOrLog.bind("[clipboard-polyfill]");

// src/clipboard-polyfill/builtins/window-globalThis.ts
var originalWindow = typeof window === "undefined" ? void 0 : window;
var originalGlobalThis = typeof globalThis === "undefined" ? void 0 : globalThis;

// src/clipboard-polyfill/builtins/promise-constructor.ts
var _a, _b, _c;
var promiseConstructorImpl = (_c = (_a = originalWindow) == null ? void 0 : _a.Promise) != null ? _c : (_b = originalGlobalThis) == null ? void 0 : _b.Promise;
function getPromiseConstructor() {
  if (!promiseConstructorImpl) {
    throw new Error(
      "No `Promise` implementation available for `clipboard-polyfill`. Consider using: https://github.com/lgarron/clipboard-polyfill#flat-file-version-with-promise-included"
    );
  }
  return promiseConstructorImpl;
}

// src/clipboard-polyfill/builtins/builtin-globals.ts
var originalNavigator = typeof navigator === "undefined" ? void 0 : navigator;
var originalNavigatorClipboard = originalNavigator == null ? void 0 : originalNavigator.clipboard;
var _a2;
var originalNavigatorClipboardRead = (_a2 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.read) == null ? void 0 : _a2.bind(
  originalNavigatorClipboard
);
var _a3;
var originalNavigatorClipboardReadText = (_a3 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.readText) == null ? void 0 : _a3.bind(
  originalNavigatorClipboard
);
var _a4;
var originalNavigatorClipboardWrite = (_a4 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.write) == null ? void 0 : _a4.bind(
  originalNavigatorClipboard
);
var _a5;
var originalNavigatorClipboardWriteText = (_a5 = originalNavigatorClipboard == null ? void 0 : originalNavigatorClipboard.writeText) == null ? void 0 : _a5.bind(
  originalNavigatorClipboard
);
var _a6;
var originalWindowClipboardItem = (_a6 = originalWindow) == null ? void 0 : _a6.ClipboardItem;
var promiseConstructor = getPromiseConstructor();

// src/clipboard-polyfill/strategies/internet-explorer.ts
var ieWindow = originalWindow;
function seemToBeInIE() {
  return typeof ClipboardEvent === "undefined" && typeof (ieWindow == null ? void 0 : ieWindow.clipboardData) !== "undefined" && typeof (ieWindow == null ? void 0 : ieWindow.clipboardData.setData) !== "undefined";
}
function writeTextIE(text) {
  if (!ieWindow.clipboardData) {
    return false;
  }
  var success = ieWindow.clipboardData.setData("Text", text);
  if (success) {
    debugLog("writeTextIE worked");
  }
  return success;
}
function readTextIE() {
  if (!ieWindow.clipboardData) {
    throw new Error("Cannot read IE clipboard Data ");
  }
  var text = ieWindow.clipboardData.getData("Text");
  if (text === "") {
    throw new Error(
      "Empty clipboard or could not read plain text from clipboard"
    );
  }
  return text;
}

// src/clipboard-polyfill/strategies/dom.ts
function copyListener(tracker, data, e) {
  debugLog("listener called");
  tracker.success = true;
  for (var type in data) {
    var value = data[type];
    var clipboardData = e.clipboardData;
    clipboardData.setData(type, value);
    if (type === TEXT_PLAIN && clipboardData.getData(type) !== value) {
      debugLog("setting text/plain failed");
      tracker.success = false;
    }
  }
  e.preventDefault();
}
function execCopy(data) {
  var tracker = { success: false };
  var listener = copyListener.bind(this, tracker, data);
  document.addEventListener("copy", listener);
  try {
    document.execCommand("copy");
  } finally {
    document.removeEventListener("copy", listener);
  }
  return tracker.success;
}
function copyUsingTempSelection(e, data) {
  selectionSet(e);
  var success = execCopy(data);
  selectionClear();
  return success;
}
function copyUsingTempElem(data) {
  var tempElem = document.createElement("div");
  tempElem.setAttribute("style", "-webkit-user-select: text !important");
  tempElem.textContent = "temporary element";
  document.body.appendChild(tempElem);
  var success = copyUsingTempSelection(tempElem, data);
  document.body.removeChild(tempElem);
  return success;
}
function copyTextUsingDOM(str) {
  debugLog("copyTextUsingDOM");
  var tempElem = document.createElement("div");
  tempElem.setAttribute("style", "-webkit-user-select: text !important");
  var spanParent = tempElem;
  if (tempElem.attachShadow) {
    debugLog("Using shadow DOM.");
    spanParent = tempElem.attachShadow({ mode: "open" });
  }
  var span = document.createElement("span");
  span.innerText = str;
  spanParent.appendChild(span);
  document.body.appendChild(tempElem);
  selectionSet(span);
  var result = document.execCommand("copy");
  selectionClear();
  document.body.removeChild(tempElem);
  return result;
}
function selectionSet(elem) {
  var sel = document.getSelection();
  if (sel) {
    var range = document.createRange();
    range.selectNodeContents(elem);
    sel.removeAllRanges();
    sel.addRange(range);
  }
}
function selectionClear() {
  var sel = document.getSelection();
  if (sel) {
    sel.removeAllRanges();
  }
}

// src/clipboard-polyfill/implementations/write-fallback.ts
function writeFallback(stringItem) {
  var hasTextPlain = TEXT_PLAIN in stringItem;
  if (seemToBeInIE()) {
    if (!hasTextPlain) {
      throw new Error("No `text/plain` value was specified.");
    }
    if (writeTextIE(stringItem[TEXT_PLAIN])) {
      return true;
    } else {
      throw new Error("Copying failed, possibly because the user rejected it.");
    }
  }
  if (execCopy(stringItem)) {
    debugLog("regular execCopy worked");
    return true;
  }
  if (navigator.userAgent.indexOf("Edge") > -1) {
    debugLog('UA "Edge" => assuming success');
    return true;
  }
  if (copyUsingTempSelection(document.body, stringItem)) {
    debugLog("copyUsingTempSelection worked");
    return true;
  }
  if (copyUsingTempElem(stringItem)) {
    debugLog("copyUsingTempElem worked");
    return true;
  }
  if (copyTextUsingDOM(stringItem[TEXT_PLAIN])) {
    debugLog("copyTextUsingDOM worked");
    return true;
  }
  return false;
}

// src/clipboard-polyfill/promise/promise-compat.ts
function promiseRecordMap(keys, f) {
  var promiseList = [];
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    promiseList.push(f(key));
  }
  return promiseConstructor.all(promiseList).then((vList) => {
    var dataOut = {};
    for (var i2 = 0; i2 < keys.length; i2++) {
      dataOut[keys[i2]] = vList[i2];
    }
    return dataOut;
  });
}
var voidPromise = promiseConstructor.resolve();
var truePromiseFn = () => promiseConstructor.resolve(true);
var falsePromise = promiseConstructor.resolve(false);
function rejectThrownErrors(executor) {
  return new promiseConstructor((resolve, reject) => {
    try {
      resolve(executor());
    } catch (e) {
      reject(e);
    }
  });
}

// src/clipboard-polyfill/implementations/text.ts
function stringToStringItem(s) {
  var stringItem = {};
  stringItem[TEXT_PLAIN] = s;
  return stringItem;
}
function writeText(s) {
  if (originalNavigatorClipboardWriteText) {
    debugLog("Using `navigator.clipboard.writeText()`.");
    return originalNavigatorClipboardWriteText(s).catch(
      () => writeTextStringFallbackPromise(s)
    );
  }
  return writeTextStringFallbackPromise(s);
}
function writeTextStringFallbackPromise(s) {
  return rejectThrownErrors(
    () => promiseConstructor.resolve(writeTextStringFallback(s))
  );
}
function writeTextStringFallback(s) {
  if (!writeFallback(stringToStringItem(s))) {
    throw new Error("writeText() failed");
  }
}
function readText() {
  return rejectThrownErrors(() => {
    if (originalNavigatorClipboardReadText) {
      debugLog("Using `navigator.clipboard.readText()`.");
      return originalNavigatorClipboardReadText();
    }
    if (seemToBeInIE()) {
      var result = readTextIE();
      return promiseConstructor.resolve(result);
    }
    throw new Error("Read is not supported in your browser.");
  });
}

// src/clipboard-polyfill/ClipboardItem/check.ts
function hasItemWithType(clipboardItems, typeName) {
  for (var i = 0; i < clipboardItems.length; i++) {
    var item = clipboardItems[i];
    if (item.types.indexOf(typeName) !== -1) {
      return true;
    }
  }
  return false;
}

// src/clipboard-polyfill/ClipboardItem/ClipboardItemPolyfill.ts
function ClipboardItemPolyfillImpl(items, options) {
  var _a7;
  var types = Object.keys(items);
  var _items = {};
  for (var type in items) {
    var item = items[type];
    if (typeof item === "string") {
      _items[type] = stringToBlob(type, item);
    } else {
      _items[type] = item;
    }
  }
  var presentationStyle = (_a7 = options == null ? void 0 : options.presentationStyle) != null ? _a7 : "unspecified";
  function getType(type2) {
    return promiseConstructor.resolve(_items[type2]);
  }
  return {
    types,
    presentationStyle,
    getType
  };
}
var ClipboardItemPolyfill = (/* unused pure expression or super */ null && (ClipboardItemPolyfillImpl));

// src/clipboard-polyfill/ClipboardItem/convert.ts
function stringToBlob(type, str) {
  return new Blob([str], {
    type
  });
}
function blobToString(blob) {
  return new promiseConstructor((resolve, reject) => {
    var fileReader = new FileReader();
    fileReader.addEventListener("load", () => {
      var result = fileReader.result;
      if (typeof result === "string") {
        resolve(result);
      } else {
        reject("could not convert blob to string");
      }
    });
    fileReader.readAsText(blob);
  });
}
function clipboardItemToGlobalClipboardItem(clipboardItem) {
  return promiseRecordMap(clipboardItem.types, function(type) {
    return clipboardItem.getType(type);
  }).then((items) => {
    return new promiseConstructor((resolve, reject) => {
      var options = {};
      if (clipboardItem.presentationStyle) {
        options.presentationStyle = clipboardItem.presentationStyle;
      }
      if (originalWindowClipboardItem) {
        resolve(new originalWindowClipboardItem(items, options));
      } else {
        reject("window.ClipboardItem is not defined");
      }
    });
  });
}
function textToClipboardItem(text) {
  var items = {};
  items[TEXT_PLAIN] = stringToBlob(text, TEXT_PLAIN);
  return new ClipboardItemPolyfill(items);
}
function getTypeAsString(clipboardItem, type) {
  return clipboardItem.getType(type).then((text) => {
    return blobToString(text);
  });
}
function toStringItem(data) {
  return promiseRecordMap(data.types, function(type) {
    return getTypeAsString(data, type);
  });
}

// src/clipboard-polyfill/implementations/blob.ts
function write(data) {
  return rejectThrownErrors(() => {
    if (originalNavigatorClipboardWrite && originalWindowClipboardItem) {
      var originalNavigatorClipboardWriteCached = originalNavigatorClipboardWrite;
      debugLog("Using `navigator.clipboard.write()`.");
      return promiseConstructor.all(data.map(clipboardItemToGlobalClipboardItem)).then(
        (globalClipboardItems) => {
          return originalNavigatorClipboardWriteCached(globalClipboardItems).then(truePromiseFn).catch((e) => {
            if (!hasItemWithType(data, TEXT_PLAIN) && !hasItemWithType(data, TEXT_HTML)) {
              throw e;
            }
            return falsePromise;
          });
        }
      );
    }
    return falsePromise;
  }).then((success) => {
    if (success) {
      return voidPromise;
    }
    var hasTextPlain = hasItemWithType(data, TEXT_PLAIN);
    if (shouldShowWarnings() && !hasTextPlain) {
      debugLog(
        "clipboard.write() was called without a `text/plain` data type. On some platforms, this may result in an empty clipboard. Call suppressWarnings() to suppress this warning."
      );
    }
    return toStringItem(data[0]).then((stringItem) => {
      if (!writeFallback(stringItem)) {
        throw new Error("write() failed");
      }
    });
  });
}
function read() {
  return rejectThrownErrors(() => {
    if (originalNavigatorClipboardRead) {
      debugLog("Using `navigator.clipboard.read()`.");
      return originalNavigatorClipboardRead();
    }
    return readText().then((text) => {
      return [textToClipboardItem(text)];
    });
  });
}

//# sourceMappingURL=clipboard-polyfill.es6.js.map


/***/ })

},
/******/ __webpack_require__ => { // webpackRuntimeModules
/******/ var __webpack_exec__ = (moduleId) => (__webpack_require__(__webpack_require__.s = moduleId))
/******/ __webpack_require__.O(0, [9876,2991,4162,114,9381,5154,9774,2888,179], () => (__webpack_exec__(77183)));
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);